export default "__VITE_ASSET__DimdVmUI__"